import { render, staticRenderFns } from "./FooterLayout.vue?vue&type=template&id=1c3d719d&scoped=true&"
import script from "./FooterLayout.vue?vue&type=script&lang=ts&"
export * from "./FooterLayout.vue?vue&type=script&lang=ts&"
import style0 from "./FooterLayout.vue?vue&type=style&index=0&id=1c3d719d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3d719d",
  null
  
)

export default component.exports